const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// A top-level const is a global but not a property of window. The Auro scripts (auro-cards.js, auro-pdp.js)
// look for window.PUB_SUB_EVENTS before they publish or subscribe, so expose it there too.
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
